// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Header.css';

function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className={`header ${open ? 'nav-open' : ''}`}>
      <nav className="navbar container">
        <div className="logo">
          <Link to="/" className="logo-link">VP</Link>
        </div>

        {/* Hamburger */}
        <button
          className="menu-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <ul className="nav-links" role="menu">
          <li role="none">
            <Link role="menuitem" to="/">Home</Link>
          </li>
          <li role="none">
            <Link role="menuitem" to="/experience">Experience</Link>
          </li>
          <li role="none">
            <Link role="menuitem" to="/projects">Projects</Link>
          </li>
          <li role="none">
            <Link role="menuitem" to="/education">Education</Link>
          </li>
          <li role="none">
            <Link role="menuitem" to="/skills">Skills</Link>
          </li>
          <li role="none">
            <Link role="menuitem" to="/contact">Contact</Link>
          </li>
        </ul>

        <div className="social-icons">
          <a href="https://www.linkedin.com/in/virajpargaonkar" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a href="mailto:virajnp@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email">
            <i className="fas fa-envelope"></i>
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Header;
